<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Examination</h1>
          <p>Enter the examination Data  </p>
      </div>
</div>


<div id="w3l-appointment">

  <div class="wrapper">
  <div class="d-grid doctor-appointment">
  <div class="styled-input">
    <label>M.R.N</label>
    <div class="appointment-form-field">
        <span class="fa fa-search" style="cursor: grab;" (click)="openDialog()" aria-hidden="true"></span>
        <input type="text" name="PatientCode" placeholder="Patient Code" [(ngModel)]="patientcode" (change)="retivePatinetName()" required="" style="width: 30%;"/>
        <input type="text" name="PatientName" placeholder="Patient Name" [(ngModel)]="patintname" required="" readonly>
    </div>
</div>
</div>
</div>
<div id="w3l-appointment">
<section class="appointment-section section-gap">
<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post">
            <div class="fields-grid">
              <div class="styled-input">
                <label>Date</label>
                  <div class="appointment-form-field">
                      <span class="fa fa-calendar" aria-hidden="true"></span>
                      <input type="date" [(ngModel)]="dateentry" (change)="retrieveexamination()" name="DateofDiagnosis" required style="width: 40%;">
                      <label> </label>
                      <a (click)="openDialogC()" class="fa fa-search" style="cursor: zoom-in; font-size:1.6ch;width: 40%;color: darkblue;">Previous Examination</a>
                  </div>
                </div>
              <div class="styled-input">
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  CBC   </label>
                <div class="styled-input">

                  <label>TLC               Hgb            MCV            MCH            PLT </label>
                  <div class="appointment-form-field">

                    <input type="text" name="TLC" placeholder=""  [(ngModel)]="cBcTlc" required="" style="width: 100%;"/>
                      <label>   </label>

                      <input type="text" name="cBcHgb" placeholder=""  [(ngModel)]="cBcHgb" required="" style="width: 100%; font-size:1.1ch;">
                      <label>   </label>

                      <input type="text" name="cBcMcV"  placeholder=""  [(ngModel)]="cBcMcV" required="" style="width: 100%;font-size:1.1ch;">
                      <label>   </label>

                      <input type="text" name="cBcMcH" placeholder=""  [(ngModel)]="cBcMcH" required="" style="width: 100%;font-size:1.1ch;">
                      <label>   </label>

                      <input type="text" name="cBcPlT" placeholder=""  [(ngModel)]="cBcPlT" required="" style="width: 100%;font-size:1.1ch;">
                      <label>   </label>
                  </div>
              </div>



               </div>
               <section class="w3l-hero-headers-11 p-sticky-md">
                <div class="top-header">
                </div>
              </section>

               <div class="styled-input">

                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Diff   </label>

                <label>Neu               Lym            Eosino            Baso            Mono </label>
                <div class="appointment-form-field">
                  <input type="text" name="Neu" placeholder="" [(ngModel)]="diftNeu"  required="" style="width: 30%;"/>
                  <input type="text" name="Lym" placeholder="" [(ngModel)]="diftlym"  required="" style="width: 30%;"/>
                  <input type="text" name="Eosino" placeholder="" [(ngModel)]="difteosino"  required="" style="width: 30%;"/>
                  <input type="text" name="Baso" placeholder="" [(ngModel)]="diftBaso"  required="" style="width: 30%;"/>
                  <input type="text" name="Mono" placeholder="" [(ngModel)]="diftMono"  required="" style="width: 30%;"/>
                </div>
                <div class="appointment-form-field">


                </div>
              </div>
              <section class="w3l-hero-headers-11 p-sticky-md">
                <div class="top-header">
                </div>

              </section>

              <div class="styled-input">
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  KFT   </label>
                <label>S.Crea                      Urea                      UricAcid            </label>
                <div class="appointment-form-field">
                  <input type="text" name="S.Crea" placeholder="" [(ngModel)]="kFTScrea"  required="" style="width: 30%;"/>
                  <input type="text" name="Urea" placeholder="" [(ngModel)]="kFTUrea"  required="" style="width: 30%;"/>
                  <input type="text" name="UricAcid" placeholder="" [(ngModel)]="kFTUricAcid"  required="" style="width: 30%;"/>

                </div>
              </div>
              <section class="w3l-hero-headers-11 p-sticky-md">


              </section>

              <div class="styled-input">

                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Electro   </label>
                <label>Na                         K                    ESR 1 hr          ESR 2 hr    </label>
                <div class="appointment-form-field">
                  <input type="text" name="Na" placeholder="" [(ngModel)]="electroNa"  required="" style="width: 30%;"/>
                  <input type="text" name="K" placeholder="" [(ngModel)]="electrok"  required="" style="width: 30%;"/>
                  <input type="text" name="ESR1" placeholder="" [(ngModel)]="electroeSR1hr"  required="" style="width: 30%;"/>
                  <input type="text" name="ESR2" placeholder="" [(ngModel)]="electroeSR2hr"  required="" style="width: 30%;"/>

                </div>
                <label>    Ca 2 (L)                      Ca 2 (T)             </label>
                <div class="appointment-form-field">


<input type="text" name="Ca1" placeholder="" [(ngModel)]="electroca1"  required="" style="width: 30%;"/>
<input type="text" name="Ca2" placeholder="" [(ngModel)]="electroca2"  required="" style="width: 30%;"/>
                </div>
                </div>

                <section class="w3l-hero-headers-11 p-sticky-md">
                  <div class="top-header">
                  </div>

                </section>

                <div class="styled-input">

                  <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Blood Sugar   </label>
                  <label>   Fasting                         Random            </label>

                  <div class="appointment-form-field">
                    <input type="text" name="Fasting" placeholder="" [(ngModel)]="bloodSugarFasting"  required="" style="width: 30%;"/>
                    <input type="text" name="Random" placeholder="" [(ngModel)]="bloodSugarRandom"  required="" style="width: 30%;"/>


                  </div>
              </div>
              <section class="w3l-hero-headers-11 p-sticky-md">
                <div class="top-header">
                </div>

              </section>

              <div class="styled-input">

                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  T.Markers   </label>
                <label>CEA                         CA15.3                  CA12.5             </label>
                <div class="appointment-form-field">
                  <input type="text" name="CEA" placeholder="" [(ngModel)]="tMarkersceA"  required="" style="width: 30%;"/>
                  <input type="text" name="CA153" placeholder="" [(ngModel)]="tMarkerscA15_3"  required="" style="width: 30%;"/>
                  <input type="text" name="CA125" placeholder="" [(ngModel)]="tMarkerscA12_5"  required="" style="width: 30%;"/>
                </div>
                <label>CA19.9                         PSA                       AFP  </label>
                <div class="appointment-form-field">
                  <input type="text" name="CA199" placeholder="" [(ngModel)]="tMarkerscA19_9"  required="" style="width: 30%;"/>
                  <input type="text" name="PSA" placeholder="" [(ngModel)]="tMarkersPSA"  required="" style="width: 30%;"/>
                  <input type="text" name="AFP" placeholder="" [(ngModel)]="tMarkersAFP"  required="" style="width: 30%;"/>
                </div>

              </div>
            </div>
        </form>
    </div>


    <div class="fields-grid">
      <div class="top-header">
        <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Attachment   </label>
        <div class="appointment-form-field">
          <input (change)="picked($event)" type="file" id="photo" name="photo" accept="image/*">
         </div>
        <div class="styled-input">
           <img src="data:image/jpg;base64,{{myimage}}" class="img-circle" alt="User Image" width="400px" height="200px" (click)="openDialogViwer()"/>
        </div>

      </div>
      <div class="styled-input">
        <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  LFT   </label>
        <label>TBill                                   DBill                                 GGT             </label>
        <div class="appointment-form-field">
          <input type="text" name="TBill" placeholder="" [(ngModel)]="lFTTBill"  required="" style="width: 30%;"/>
          <input type="text" name="DBill" placeholder="" [(ngModel)]="lFTdBill"  required="" style="width: 30%;"/>
          <input type="text" name="GGT" placeholder="" [(ngModel)]="lFTGGT"  required="" style="width: 30%;"/>


        </div>
        <label>AST                                   ALT                                ALKPH             </label>
        <div class="appointment-form-field">

        <input type="text" name="AST" placeholder="" [(ngModel)]="lFTAST_SGoT"  required="" style="width: 30%;"/>
          <input type="text" name="ALT" placeholder="" [(ngModel)]="lFTAlT_SGPT"  required="" style="width: 30%;"/>
          <input type="text" name="ALKPH" placeholder="" [(ngModel)]="lFTAlkPH"  required="" style="width: 30%;"/>

        </div>
        <label>ALB                                   LDH                                PC             </label>
        <div class="appointment-form-field">
        <input type="text" name="ALB" placeholder="" [(ngModel)]="lFTAlB"  required="" style="width: 30%;"/>
          <input type="text" name="LDH" placeholder="" [(ngModel)]="lFTldH"  required="" style="width: 30%;"/>
          <input type="text" name="PC" placeholder="" [(ngModel)]="lFTPc"  required="" style="width: 30%;"/>

        </div>
        <label>PT                                   INR             </label>
        <div class="appointment-form-field">
            <input type="text" name="PT" placeholder="" [(ngModel)]="lFTPT"  required="" style="width: 30%;"/>
            <input type="text" name="INR" placeholder="" [(ngModel)]="lFTINR"  required="" style="width: 30%;"/>
          </div>

      </div>


      <div class="styled-input">

        <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Others   </label>
        <div class="appointment-form-field">
          <input type="text" name="Other1" placeholder="OtherName1" [(ngModel)]="other1"  required="" style="width: 30%;"/>
          <input type="text" name="Other2" placeholder="OtherValue1" [(ngModel)]="other2"  required="" style="width: 30%;"/>

        </div>
        <div class="appointment-form-field">
          <input type="text" name="Other3" placeholder="OtherName2" [(ngModel)]="other3"  required="" style="width: 30%;"/>
          <input type="text" name="Other4" placeholder="OtherValue2" [(ngModel)]="other4"  required="" style="width: 30%;"/>

        </div>
        <div class="appointment-form-field">
          <input type="text" name="Other5" placeholder="OtherName3" [(ngModel)]="other5"  required="" style="width: 30%;"/>
          <input type="text" name="Other6" placeholder="OtherValue3" [(ngModel)]="other6"  required="" style="width: 30%;"/>

        </div>
        <div class="appointment-form-field">
          <input type="text" name="Other7" placeholder="OtherName3" [(ngModel)]="other7"  required="" style="width: 30%;"/>
          <input type="text" name="Other8" placeholder="OtherValue3" [(ngModel)]="other8"  required="" style="width: 30%;"/>

        </div>

    </div>

    </div>
</div>
</div>
</section>
</div>
<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
      <div class="appointment-form">
  <button type="button" class="theme-button btn" name="submit" (click)="submitData()">Submit</button>
  <button type="button" class="theme-button btn" name="Delete">Delete</button>
  <button type="button" class="theme-button btn" name="Clear" (click)="ClearexaminationData()">Next</button>
  <a href="Home">
    <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
  </a>
</div>
</div>
</div>
<BR>
<BR>



</div>


